module.exports = __webpack_public_path__ + "static/media/gotoAppAndroid.3cab4b45.png";